import { RootPaths } from "@src/appV2/App/paths";

export const SOCIAL_PATH = "social";
export const SOCIAL_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SOCIAL_PATH}`;

export const DISCOVER_PATH = "discover";
export const DISCOVER_FULL_PATH = `${SOCIAL_FULL_PATH}/${DISCOVER_PATH}`;

export const FEED_PATH = "feed";
export const FEED_FULL_PATH = `${SOCIAL_FULL_PATH}/${FEED_PATH}`;

export const CATCH_UP_PATH = "catch-up";
export const CATCH_UP_FULL_PATH = `${SOCIAL_FULL_PATH}/${CATCH_UP_PATH}`;

export const CHATS_PATH = "chats";
export const CHATS_FULL_PATH = `${SOCIAL_FULL_PATH}/${CHATS_PATH}`;
